"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.apiDataFail = function (requestKey, errorBody, response) {
  return {
    type: 'API_DATA_FAIL',
    payload: {
      requestKey: requestKey,
      response: response,
      errorBody: errorBody
    }
  };
};